// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"419":"0a3744dc","815":"b9f418a0"}[chunkId] + ".chunk.css";
};